import React from "react";
import DisplayError from "../../common/DisplayError";
import HtmlElement from "../../common/HtmlElement";
import RadioOption from "../RadioOption";
import "./AgreementField.css";
import type { BaseFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

const AgreementField: React.FC<BaseFieldProps> = (props) => {
  const form = useFormContext();
  const { field, validationsObject } = props;
  const { formState: { errors } } = form;
  const error = errors[field.name];

  return (
    <div className="text-center">
      <div className="col-12 border border-dashed mt-4 mb-4" />
      <HtmlElement elements={field.label} />
      <div className="radio-options-container">
        {field.options?.map((opt) => (
          <RadioOption
            key={`${field.name}_${opt.key}`}
            field={field}
            opt={opt}
            validationsObject={validationsObject}
          />
        ))}
      </div>
      <DisplayError
        errorCondition={error}
        errorMessage={error?.message as string}
      />
    </div>
  );
};

export default AgreementField;
